<template>
    <div class="mt-8 flex flex-row items-center justify-center gap-6">
        <LangSwitch />
        <FleequidCustomerServiceContact />
    </div>
</template>
